var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.342,
    height: 20.483,
    viewBox: "0 0 22.342 20.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.329 -21.258)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 21,
    y2: 19,
    transform: "translate(15 22)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 19,
    x2: 21,
    transform: "translate(15 22)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.da7911cf92e4e9cdc28e59e6515c5138.svg";
export { ForwardRef as ReactComponent };